import { render, staticRenderFns } from "./Rate.vue?vue&type=template&id=38710e9b&scoped=true&"
import script from "./Rate.vue?vue&type=script&lang=js&"
export * from "./Rate.vue?vue&type=script&lang=js&"
import style0 from "./Rate.vue?vue&type=style&index=0&id=38710e9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38710e9b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38710e9b')) {
      api.createRecord('38710e9b', component.options)
    } else {
      api.reload('38710e9b', component.options)
    }
    module.hot.accept("./Rate.vue?vue&type=template&id=38710e9b&scoped=true&", function () {
      api.rerender('38710e9b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/projects/rate/Rate.vue"
export default component.exports